<form class="row needs-validation" novalidate>
  <div class="row">
    <div class="col-xl-12">
      <div class="form-row">
        <div class="form-floating mb-4 col-md-12">
          <input type="text" class="form-control col-md-12" [class.is-invalid]="errorLocation === true" id="searchLocation" name="searchLocation" placeholder=" "
            (keydown.enter)="$event.preventDefault()" autocorrect="off" [(ngModel)]="locationAddress"
            autocapitalize="off" spellcheck="off" #search
            [disabled]="disabled" />

          <label for="searchLocation" translate>Search for location</label>
          <div class="invalid-feedback" translate>
            Location error
          </div>
        </div>
        <div class="form-floating mb-4 col-md-12">
          <input id="locationName" type="text" class="form-control col-md-12" placeholder=" "
            [(ngModel)]="locationName" (focusout)="addLocationInfo()" [disabled]="disabled" name="location" />
          <label for="locationName" translate>Location name</label>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-12 mb-4">
      <!-- <agm-map
      #agmMap
      [latitude]="latitude"
      [longitude]="longitude"
      [zoom]="zoom"
      (mapClick)="placeMarker($event)"
    >
      <agm-marker
        [latitude]="latitude"
        [longitude]="longitude"
        [markerDraggable]="draggable"
        [iconUrl]="mapPin"
        (dragEnd)="markerDragEnd($event)"
      ></agm-marker>
    </agm-map> -->
    <app-google-maps #googleMap (mapClick)="placeMarker($event)"></app-google-maps>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-12">
      <div class="form-row">
        <div class="form-floating col-md-12">
          <textarea type="text" class="form-control" id="description" name="description" [(ngModel)]="locationDesc"
            (focusout)="addLocationInfo()" placeholder=" " [disabled]="!locationAddress || disabled"
            maxlength="2000" style="height: 150px;"></textarea>
          <label for="description" translate>Your location description</label>
        </div>
      </div>
    </div>
  </div>
</form>